const escapeManualInput = (text) => {
  return text.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&')
}

const getMatchedConstituencyNames = (dictionary, input) => {
  return dictionary
    .filter(constituency => {
      const regex = new RegExp(`\\b${escapeManualInput(input)}`, 'gi')
      return regex.test(constituency.name)
    })
}

export {getMatchedConstituencyNames}
